import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ADPResourceService, CustomFormControl } from 'digital-core';
import { CountryCode, isValidPhoneNumber } from 'libphonenumber-js';
import { combineLatest, concatMap, filter, tap } from 'rxjs';
import { DeviceInventoryService } from 'src/app/core/services/device-inventory.service';
import { DeviceDto } from 'src/app/core/services/device-inventory/device.dto';
import { InventoryInfoDto } from 'src/app/core/services/device-inventory/inventory-info.dto';
import { ISelectedContract, LoggedInUserSettings } from 'src/app/core/services/settings/logged-in-user-settings';
import { UtilityService } from 'src/app/core/services/utility.service';
import { PghUserDeviceBase } from 'src/app/shared/device/pgh-user-device';
import { SelectedDeviceService } from 'src/app/shared/device/selected-device.service';
import { StorageService } from 'src/app/core/services/storage.service';
import { AccountService } from 'src/app/core/services/account.service';
import { UpdateUserInfoDevicesCountDto } from 'src/app/model/account/update-user-info-devices-count.dto';
import { UserInfoReportingService } from 'src/app/core/services/user-info-refporting.service';
import { UserClaims } from '@okta/okta-auth-js';

@Component({
  selector: 'pgh-register-number',
  templateUrl: './register-number.component.html',
  styleUrls: ['./register-number.component.scss']
})
export class RegisterNumberComponent implements OnInit {
  @Output() registerPhoneNumberEvent = new EventEmitter();
  @Output() nextEvent = new EventEmitter();
  @Output() backEvent = new EventEmitter();
  @Input() isOnboardingFlow?: boolean = false;
  countryIso: CountryCode = 'US';

  phoneNumberForm = new UntypedFormGroup({
    mobileNumber: new CustomFormControl('', [])
  });
  programCode: string;
  device: PghUserDeviceBase;
  private phoneInventoryInfo?: InventoryInfoDto;
  private phoneDevices?: DeviceDto[];
  mobileNumberControl: UntypedFormControl = this.phoneNumberForm.get('mobileNumber') as UntypedFormControl;
  public userEmail:string;

  constructor(
    public resourceService: ADPResourceService,
    private deviceInventoryService: DeviceInventoryService,
    private selectedDeviceService: SelectedDeviceService,
    private utilityServce: UtilityService,
    private loggedInUserSettings: LoggedInUserSettings,
    private storageService: StorageService,
    private accountService: AccountService,
    private userInfoReportingService: UserInfoReportingService,
    private loggedInUserSettingsService: LoggedInUserSettings,
  ) { }


  ngOnInit(): void {
    this.device = this.selectedDeviceService.getSelectedDevice();    
    this.programCode = this.resourceService.getPortalSetting("Global_ProgramCode").Value;
    const joined$ = combineLatest(
      [
        this.loggedInUserSettings.$selectedContract,
        this.loggedInUserSettingsService.$userClaims,
      ]
    ).pipe(
      filter(([a, b]) => a !== null && b !== null)
    );
    joined$.subscribe(([contract, user]: [ISelectedContract, UserClaims]) => {
      this.userEmail = user.email;
      this.deviceInventoryService.getInventoryInfo(contract.certificateNumberForPhonesPolicy ? contract.certificateNumberForPhonesPolicy : contract.certificateNumberForGadgetsPolicy, this.programCode, contract.dealerId).pipe(
        tap(inventory => this.phoneInventoryInfo = inventory),
        concatMap(inventory => this.deviceInventoryService.getDevices(inventory.id))
      ).subscribe({
        next: (phones) => {
          this.phoneDevices = phones ?? [];
        }
      });
    });
  }
  validatePhone(control: UntypedFormControl) {
    if (control?.value != null) {
      let phNumber = control.value.replace(/[^0-9]/g, "");
      let checkPH = isValidPhoneNumber(phNumber, this.countryIso);
      if (!this.isValidPhoneFormat(control.value)) {
        return { invalidFormat: true };
      } else if (!checkPH) {
        return { invalid: true };
      }
    }
  }
  isValidPhoneFormat(phoneNumber) {
    var isphone = /^[+]?(1\-|1\s|1|\d{3}\-|\d{3}\s|)?((\(\d{3}\))|\d{3})(\-|\s)?(\d{3})(\-|\s)?(\d{4})$/g.test(phoneNumber);
    return isphone;
  }

  public handleRegisterPhoneNumber() {
    const isEprism = this.storageService.getLocal<string>(`IsEprismOnly`);
    if (isEprism == 'true') {
      return;
    }
    const phoneNmber = this.phoneNumberForm.controls.mobileNumber.value;
    if (this.isOnboardingFlow){
      this.deviceInventoryService.addPhoneNumberToInventory(
        this.utilityServce.getPhoneNumberInE164(phoneNmber), this.phoneInventoryInfo?.id, false
      ).subscribe(res => {
        this.accountService.registerInvitationToDevice(
          res.id, res.inventoryId, true, this.utilityServce.getPhoneNumberForTwilio(phoneNmber)
        ).subscribe(res => {
          /*if (resendInvitephoneNumber) {
            this.snackbarService.showSimpleMessage(this.resourceService.getPortalLabel("DeviceInventory_Invite_ReSent").Value);
          } else {
            this.loadDiagnosticDevices();
            this.snackbarService.showSimpleMessage(this.resourceService.getPortalLabel("DeviceInventory_Invite_Sent").Value);
          }*/
            this.selectedDeviceService.updateAllDevices(res);
          //update the user's inventory device count in the UserInfo db
          const updateUserInfoDevicesCountDto : UpdateUserInfoDevicesCountDto = {
            EmailAddress: this.userEmail,
            DeviceCount: this.selectedDeviceService.getAllDevices().length
          }
          this.userInfoReportingService.updateUserInfoDevicesCount(updateUserInfoDevicesCountDto).subscribe({error: (err) => { throw err;}});
          this.nextEvent.emit(phoneNmber);
        });
      });
    } else {
      let nickName = this.getUniqueNickname(this.device.make, this.device.model);
      this.deviceInventoryService.addPhoneNumberToInventory(
        this.utilityServce.getPhoneNumberInE164(phoneNmber), this.phoneInventoryInfo?.id, false, nickName, this.device.make, this.device.model
      ).subscribe(device => {
        this.selectedDeviceService.updateAllDevices(device);
        const updateUserInfoDevicesCountDto : UpdateUserInfoDevicesCountDto = {
          EmailAddress: this.userEmail,
          DeviceCount: this.selectedDeviceService.getAllDevices().length
        }
        this.userInfoReportingService.updateUserInfoDevicesCount(updateUserInfoDevicesCountDto).subscribe({error: (err) => { throw err;}});
        this.storageService.setSession<DeviceDto>('NewUserDevice', device);
        this.nextEvent.emit(phoneNmber);
      });
    }
  }

  getUniqueNickname(make: string, model: string): string {
    let count = this.phoneDevices.filter(x => x.make?.toLowerCase() === make.toLowerCase() && x.model?.toLowerCase() === model.toLowerCase()).length;
    return `${make} ${model} ${count > 0 ? count + 1 : ''}`.trim();
  }

}
